export const intToDollar = (amount: number) => {
  return `$${(amount / 100).toFixed(2)}`;
};
